// extracted by mini-css-extract-plugin
export default {"root":"IconInquiry_root__pbgUJ","marketplaceColorStroke":"IconInquiry_marketplaceColorStroke__Deni+"};